import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import NotFound from './screens/error/NotFound';
import Callback from './screens/callback/Callback';
import Maintenance from './screens/maintenance/Maintenance';
import { StepContextProvider } from './context/StepContext';
import PersonalInformation from './screens/personalInformation/PersonalInformation';
import BusinessInformation from './screens/businessInformation/BusinessInformation';
import Locations from './screens/location/Locations';
import MFA from './screens/mfa/MFA';
import ProductsChoice from './screens/products/ProductsChoice';
import SidekickProducts from './screens/products/sidekickProducts/SidekickProducts';
import Categories from './screens/products/categories/Categories';
import Products from './screens/products/productsList/Products';
import StaffRoles from './screens/staffRoles/StaffRoles';
import StaffList from './screens/staff/StaffList';
import Confirmation from './screens/confirmation/Confirmation';
import Welcome from './screens/welcome/Welcome';
import NoSteps from './screens/noSteps/NoSteps';
import Verification from './screens/verification/Verification';
import BankAccount from './screens/bankAccount/BankAccountSelection';
import CatalogueImportSidekick from './screens/products/sidekickImportProducts/CatalogueImportSidekick';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
const AppRoutes = () => (
  <SentryRoutes>
    <Route element={<StepContextProvider />}>
      <Route path="/" element={<Welcome />} />
      <Route path="personal-info" element={<PersonalInformation />} />
      <Route path="business-info" element={<BusinessInformation />} />
      <Route path="bank-account" element={<BankAccount />} />
      <Route path="locations" element={<Locations />}>
        <Route path=":addressId" element={null} />
      </Route>
      <Route path="mfa" element={<MFA />} />
      <Route path="products" element={<ProductsChoice />} />
      <Route path="products-sidekick" element={<SidekickProducts />} />
      <Route path="products-categories" element={<Categories />}>
        <Route path=":objectId" element={null} />
      </Route>
      <Route path="products-list" element={<Products />}>
        <Route path=":objectId" element={null} />
      </Route>
      <Route path="products-import" element={<CatalogueImportSidekick />} />
      <Route path="staff" element={<Navigate to="/staff-roles" replace />} />
      <Route path="staff-roles" element={<StaffRoles />}>
        <Route path=":objectId" element={null} />
      </Route>
      <Route path="staff-list" element={<StaffList />}>
        <Route path=":objectId" element={null} />
      </Route>
      <Route path="verification" element={<Verification />} />
      <Route path="confirmation" element={<Confirmation />} />
    </Route>
    <Route path="no-steps" element={<NoSteps />} />
    <Route path="*" element={<NotFound />} />
    <Route path="/maintenance" element={<Maintenance />} />
    <Route path="/callback" element={<Callback />} />
  </SentryRoutes>
);
export default AppRoutes;
